export const APPLICATION_ROOT_ID = 'root'
export const APPLICATION_CUSTOM_SCHEME = 'fotoyu://'
